import React from 'react';
import { jsx } from '@emotion/core';
import theme from '../../../theme/theme';
/**@jsx jsx*/

function stripSpaces(string: string) {
  return string.split(' ').join('').toLowerCase();
}

interface MiniNavProps {
  sections?: string[];
  currentStep?: number;
  onStepClick?: (stepIndex: number) => void;
}

const MiniNav: React.FC<MiniNavProps> = ({ 
  sections = [], 
  currentStep = 0,
  onStepClick 
}) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, index: number) => {
    e.preventDefault();
    if (onStepClick) {
      onStepClick(index);
    }
  };

  const isActiveSection = (index: number) => {
    return currentStep === index;
  };

  return (
    <div
      css={{
        a: {
          display: 'block',
          textTransform: 'capitalize',
          padding: '6px 8px',
          fontSize: '12px',
          borderRadius: '4px',
          cursor: 'pointer',
          transition: 'all 0.2s ease',
        },
      }}>
      {sections.map((section, index) => {
        const isActive = isActiveSection(index);
        return (
          <a
            css={{
              color: isActive
                ? theme.colors.blue[600]
                : theme.colors.gray[400],
              background: isActive
                ? theme.colors.blue[50]
                : theme.colors.gray[0],
              '&:hover': {
                background: isActive
                  ? theme.colors.blue[50]
                  : theme.colors.gray[50],
                transform: 'translateX(2px)',
              },
            }}
            key={index}
            href={'#' + stripSpaces(section)}
            onClick={(e) => handleClick(e, index)}
          >
            {section}
          </a>
        );
      })}
    </div>
  );
};

export default MiniNav;